//Parroquia Zulia
const munAlmirantePadilla = ['Isla de Toas', 'Monagas'];
const munBaralt = [
  'San Timoteo',
  'General Urdaneta',
  'Libertador',
  'Manuel Guanipa Matos ',
  'Marcelino Briceño ',
  'Pueblo Nuevo',
];
const munCabimas = [
  'Ambrosio',
  'Carmen Herrera',
  'Germán Ríos Linares',
  'La Rosa',
  'Jorge Hernández',
  'Rómulo Betancourt',
  'San Benito',
  'Arístides Calvani',
  'Punta Gorda',
];
const munCatatumbo = ['Encontrados', 'Udón Pérez'];
const munColón = [
  'San Carlos del Zulia',
  'Moralito',
  'Santa Bárbara',
  'Santa Cruz del Zulia',
  'Urribarri ',
];
const munFranciscoJavierPulgar = [
  'Simón Rodríguez',
  'Carlos Quevedo',
  'Francisco Javier Pulgar',
];
const munJesúsEnriqueLossada = [
  'La Concepción',
  'José Ramón Yepes',
  'Mariano Parra León',
  'San José',
];
const munJesúsMaríaSemprún = ['Jesús María Semprún', 'Barí'];
const munLaCañadadeUrdaneta = [
  'Concepción',
  'Andrés Bello',
  'Chiquinquirá',
  'El Carmelo',
  'Potreritos',
];
const munLagunillas = [
  'Alonso de Ojeda',
  'Libertad',
  'Campo Lara',
  'Eleazar López Contreras',
  'Venezuela',
  'El Danto',
];
const munMachiquesdePerijá = [
  'Libertad',
  'Bartolomé de las Casas ',
  'Río Negro ',
  'San José de Perijá ',
];
const munMara = [
  'San Rafael',
  'La Sierrita',
  'Las Parcelas',
  'Luis de Vicente',
  'Monseñor Marcos',
  'Ricaurte',
  'Tamare',
];
const munMaracaibo = [
  'Antonio Borjas Romero',
  'Bolívar',
  'Cacique Mara',
  'Caracciolo Parra Pérez',
  'Cecilio Acosta',
  'Cristo de Aranza',
  'Coquivacoa',
  'Chiquinquirá',
  'Francisco Eugenio Bustamante',
  'Idelfonso Vásquez',
  'Juana de Ávila',
  'Luis Hurtado Higuera',
  'Manuel Dagnino',
  'Olegario Villalobos',
  'Raúl Leoni',
  'Santa Lucía',
  'Venancio Pulgar',
  'San Isidro',
];
const munMirandaZulia = [
  'Altagracia',
  'Ana María Campos',
  'Faría',
  'San Antonio',
  'San José',
  'José Antonio Chaves',
];
const munIndígenaBolivarianoGuajira = [
  'Sinamaica',
  'Alta Guajira',
  'Elías Sánchez Rubio',
  'Guajira',
];
const munRosariodePerijá = ['El Rosario', 'Donaldo García', 'Sixto Zambrano'];
const munSanFranciscoZulia = [
  'San Francisco',
  'El Bajo',
  'Domitila Flores',
  'Francisco Ochoa  ',
  'Los Cortijos',
  'Marcial Hernández',
  'José Domingo Rus',
];
const munSantaRita = [
  'Santa Rita',
  'El Mene',
  'José Cenovio Urribarri',
  'Pedro Lucas Urribarri',
];
const munSimónBolívarZulia = [
  'Manuel Manrique',
  'Rafael María Baralt',
  'Rafael Urdaneta',
];
const munSucreZulia = [
  'Bobures',
  'El Batey',
  'Gibraltar',
  'Heras ',
  'Monseñor Arturo Celestino Álvarez',
  'Rómulo Gallegos',
];
const munValmoreRodríguez = ['La Victoria', 'Rafael Urdaneta', 'Raúl Cuenca'];

export const esZulia = [
  {
    municipio: 'Almirante Padilla',
    parroquias: munAlmirantePadilla,
  },
  {
    municipio: 'Baralt',
    parroquias: munBaralt,
  },
  {
    municipio: 'Cabimas',
    parroquias: munCabimas,
  },
  {
    municipio: 'Catatumbo',
    parroquias: munCatatumbo,
  },
  {
    municipio: 'Colón',
    parroquias: munColón,
  },
  {
    municipio: 'Francisco Javier Pulgar',
    parroquias: munFranciscoJavierPulgar,
  },
  {
    municipio: 'Jesús Enrique Lossada',
    parroquias: munJesúsEnriqueLossada,
  },
  {
    municipio: 'Jesús María Semprún',
    parroquias: munJesúsMaríaSemprún,
  },
  {
    municipio: 'La Cañadade Urdaneta',
    parroquias: munLaCañadadeUrdaneta,
  },
  {
    municipio: 'Lagunillas',
    parroquias: munLagunillas,
  },
  {
    municipio: 'Machiques de Perijá',
    parroquias: munMachiquesdePerijá,
  },
  {
    municipio: 'Mara',
    parroquias: munMara,
  },
  {
    municipio: 'Maracaibo',
    parroquias: munMaracaibo,
  },
  {
    municipio: 'Miranda',
    parroquias: munMirandaZulia,
  },
  {
    municipio: 'Indígena Bolivariano Guajira',
    parroquias: munIndígenaBolivarianoGuajira,
  },
  {
    municipio: 'Rosario de Perijá',
    parroquias: munRosariodePerijá,
  },
  {
    municipio: 'San Francisco',
    parroquias: munSanFranciscoZulia,
  },
  {
    municipio: 'Santa Rita',
    parroquias: munSantaRita,
  },
  {
    municipio: 'Simón Bolívar',
    parroquias: munSimónBolívarZulia,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucreZulia,
  },
  {
    municipio: 'Valmore Rodríguez',
    parroquias: munSanFranciscoZulia,
  },
];
